export { default } from './LeadGenBanner';
